 const allUrl = {
	mapkey:'BAGBZ-QEYCI-YHRGZ-5V7RY-D6JOH-T4BHO',//地图key
	websocketUrl:'wss://device.vpowerbank.com/websocket/',//websocket接口
	uploadImage:'http://192.168.1.131:8081/other/VmpIndex/uploadImage',//图片上传
	imgUrl:'https://vdian-wechat-sz.oss-cn-shenzhen.aliyuncs.com/v_selection/image/'//图片地址
 }
//导出
export default{
	allUrl
}